import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  addProductTitle: {
    id: '8tHcL3',
    description: 'Title for add product to supplier modal',
    defaultMessage: 'Add Product',
  },
  productLabel: {
    id: '8BHm/9',
    description: 'Label for product dropdown',
    defaultMessage: 'Product',
  },
  supplierSkuLabel: {
    id: 'QZJmwH',
    description: 'Label for supplier SKU input',
    defaultMessage: 'Supplier SKU',
  },
  unitCostLabel: {
    id: 'tOKhxu',
    description: 'Label for unit cost input',
    defaultMessage: 'Unit Cost',
  },
  productPlaceholder: {
    id: '/VTaMz',
    description: 'Placeholder for product dropdown',
    defaultMessage: 'Search product by UPC or SKU',
  },
  supplierSkuPlaceholder: {
    id: 'qUtwY8',
    description: 'Placeholder for supplier SKU input',
    defaultMessage: 'Enter supplier SKU',
  },
  costPlaceholder: {
    id: '0nh9ct',
    description: 'Placeholder for cost input',
    defaultMessage: '0.00',
  },
  cancel: {
    id: 'hHNj31',
    description: 'Cancel button text',
    defaultMessage: 'Cancel',
  },
  save: {
    id: 'RT8KNi',
    description: 'Save button text',
    defaultMessage: 'Save',
  },
  errorNotificationTitle: {
    id: 'P/ltjn',
    description: 'Error notification title',
    defaultMessage: 'Error',
  },
  errorNotificationContent: {
    id: 'iQo+36',
    description: 'Error notification content',
    defaultMessage: 'Failed to create the product-supplier association. Please try again.',
  },
  editSupplierTitle: {
    id: '0UNMaX',
    description: 'Title for edit supplier modal',
    defaultMessage: 'Edit Supplier',
  },
  updateErrorNotificationContent: {
    id: 'psXFI2',
    description: 'Error notification content for update',
    defaultMessage: 'Failed to update the supplier information. Please try again.',
  },
  searchMinimumCharactersInfo: {
    id: '/WOfnk',
    description: 'Info message for minimum search characters',
    defaultMessage: 'Search term should be at least 3 characters long',
  },
  productRequiredError: {
    id: 'EJx0al',
    description: 'Error message when product is not selected',
    defaultMessage: 'Please select a product',
  },
  costRequiredError: {
    id: 'KMjLb5',
    description: 'Error message when cost is required',
    defaultMessage: 'Please enter a valid cost',
  },
  costInvalidError: {
    id: 'klS3ok',
    description: 'Error message when cost is invalid',
    defaultMessage: 'Cost must be a positive number',
  },
});
